/**
 * Thin wrapper around `location.reload()` used by the chunk-load recovery
 * path. Extracted as its own module so tests can mock the side effect —
 * jsdom marks `Location.prototype.reload` as non-configurable, which
 * blocks spying on it directly.
 */
export const reloadPage = (): void => {
  globalThis.location.reload()
}
